import Endpoints from 'constants/Endpoints';
import {RestRequestDELETE, RestRequestGET, RestRequestPOST, RestRequestPUT} from 'libs/RestRequest';
import reduxStore from 'redux/store'
import {clearResource, setResource, setSaveStatusDialog, setSaveStatusError, setSaveStatusLoading} from 'redux/actions'
import validateSection from './helpers/validateSection';
import {DemandValidation} from 'constants/DemandValidation';
import Tr from 'translations/Translations';
import objectExtension from 'libs/objectExtension';
import CommissionUserType from "../constants/CommissionUserType";

const COMMISSION_USER_LIST_RESOURCE_ID = 'commissionUserList';
const COMMISSION_USER_LIST_AVAILABLE_RESOURCE_ID = 'commissionUserListAvailable';
const COMMISSION_ESTABLISHMENT_RESOURCE_ID = 'commissionEstablishmentDate';
const getUsers = async (demandId) => {
    try {
        const res = await RestRequestGET(Endpoints.COMMISSION(demandId))
        reduxStore.dispatch(setResource(COMMISSION_USER_LIST_RESOURCE_ID, res.users))
        reduxStore.dispatch(setResource(COMMISSION_ESTABLISHMENT_RESOURCE_ID, res.establishmentDate))
    } catch (error) {
    }
}

const getAvailableUsers = async (demandId) => {
    try {
        const res = await RestRequestGET(Endpoints.COMMISSION_AVAILABLE(demandId))
        reduxStore.dispatch(setResource(COMMISSION_USER_LIST_AVAILABLE_RESOURCE_ID, res))
    } catch (error) {
    }
}

const _save = async (url, data) => {
    const {resources} = reduxStore.getState()
    const {commissionUserList} = resources;
    const diff = objectExtension.diff(data, {users: commissionUserList}, true);

    if (diff === null) return null;

    try {
        return await RestRequestPOST(url, data)
    } catch (error) {
    }
}

const saveUserList = async (demandId, data) => {
    reduxStore.dispatch(setSaveStatusLoading());
    try {
        const res = await _save(Endpoints.COMMISSION(demandId), data)
        if (res === null) {
            reduxStore.dispatch(setSaveStatusDialog());
        } else if (res.success) {
            reduxStore.dispatch(setSaveStatusDialog());
            await validateSection(DemandValidation.COMMISSION, demandId);
        } else {
            reduxStore.dispatch(setSaveStatusError(Tr(res.errors.users)));
            await validateSection(DemandValidation.COMMISSION, demandId, false);
        }
    } catch (error) {
    }
}

const addExternal = async (values) => {
    return await RestRequestPOST(Endpoints.COMMISSION_EXTERNAL, values);
}

const getHistory = async (demandId) => {
    try {
        return await RestRequestGET(Endpoints.COMMISSION_HISTORY(demandId))
    } catch (error) {
    }
}

const deleteCommissionMember = async (demandId, id) => {
    try {
        await RestRequestDELETE(Endpoints.COMMISSION_DELETE_COMMISION_MEMBER(demandId, id))
    } catch (error) {
    }
}

const markHistorical = async (demandId, id) => {
    try {
        await RestRequestPUT(Endpoints.COMMISSION_MARK_HISTORICAL_MEMBER(demandId, id))
        const {resources} = reduxStore.getState();
        reduxStore.dispatch(setResource(COMMISSION_USER_LIST_AVAILABLE_RESOURCE_ID,
            resources[COMMISSION_USER_LIST_AVAILABLE_RESOURCE_ID].filter(x => !(x.userType === CommissionUserType.EXTERNAL_USER && x.id === id))))
    } catch (error) {
    }
}

const validate = async (demandId) => {
    return RestRequestGET(Endpoints.COMMISSION_VALIDATE(demandId));
}
const clearResources = async (id) => {
    reduxStore.dispatch(clearResource(id));
}

const checkForDraft = async (id) => {
    return await RestRequestGET(Endpoints.COMMISSION_AUTOSAVE_CHECK(id));
}

const loadDraft = async (id) => {
    const res = await RestRequestGET(Endpoints.COMMISSION_AUTOSAVE(id));
    reduxStore.dispatch(setResource(COMMISSION_USER_LIST_RESOURCE_ID, res.result.users));
    reduxStore.dispatch(setResource(COMMISSION_ESTABLISHMENT_RESOURCE_ID, res.result.establishmentDate));
    return res;
}

const saveDraft = async (id, formValues) => {
    await RestRequestPOST(Endpoints.COMMISSION_AUTOSAVE(id), formValues)
}

const deleteDraft = async (id) => {
    await RestRequestDELETE(Endpoints.COMMISSION_AUTOSAVE(id));
}

export default {
    saveUserList,
    addExternal,
    getHistory,
    getUsers,
    getAvailableUsers,
    deleteCommissionMember,
    markHistorical,
    validate,
    clearResources,
    checkForDraft,
    loadDraft,
    saveDraft,
    deleteDraft,
    COMMISSION_USER_LIST_RESOURCE_ID,
    COMMISSION_USER_LIST_AVAILABLE_RESOURCE_ID,
    COMMISSION_ESTABLISHMENT_RESOURCE_ID
    // autoSave,
    // autoSaveCheck,
    // autoSaveDelete,
    // autoSaveLoad,
    // restoreAutosave,
}